<template>
  <div class="home" :style="'height:' + (getViewHeight() + 165) + 'px;'">
    <div class="hometop">
      <el-row>
        <el-col :span="14"><span>营业概览</span>
          <span style="font-size: 15px; margin-left: 20px; color: #909399"><i class="el-icon-time"
              style="margin-right: 10px"></i>统计时间：{{
                listQuery.querymodel.begintime
              }}
            至 {{ listQuery.querymodel.endtime }}</span>
        </el-col>
        <el-col :span="10" style="text-align: right">
          <el-radio-group size="small" @change="changedate()" v-model="tabPosition">
            <el-radio-button label="1">今天</el-radio-button>
            <el-radio-button label="2">昨天</el-radio-button>
            <el-radio-button label="3">本周</el-radio-button>
            <el-radio-button label="5">本月</el-radio-button>
            <el-radio-button label="6">本年</el-radio-button>
          </el-radio-group></el-col>
      </el-row>
    </div>
    <div>
      <el-row :gutter="10">
        <el-col v-for="(item, index) in data.metrics" :key="index" :span="3">
          <div @click="changetype(item)" class="boxitem" :class="item.metrimark === active ? 'active' : ''">
            <p>
              <span :class="'color_' + (index + 1)"></span>{{ item.metriname }}
            </p>
            <p>
              {{ Number(item.value).toFixed(2) }}
            </p>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="salestrendbox">
      <p class="salestrendbox_title">{{ this.salerendname }}趋势</p>
      <div id="salestrend" style="width: 100%; height: 360px"></div>
    </div>
    <el-row :gutter="10">
      <el-col :span="12">
        <div class="salestrendbox">
          <p class="salestrendbox_title">支付方式</p>
          <div id="payway" style="width: 100%; height: 360px"></div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="salestrendbox">
          <p class="salestrendbox_title">支付来源</p>
          <div id="paytype" style="width: 100%; height: 360px"></div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<style>
.hometop {
  height: 45px;
}

.home {
  background-color: #f0f2f5;
  padding: 20px;
}

.salestrendbox {
  margin-top: 10px;
  background: #f5f7fa;
  padding: 2px 16px;
}

.salestrendbox_title {
  font-size: 16px;
  color: #333;
  position: relative;
  text-indent: 10px;
}

.salestrendbox_title::before {
  content: "";
  width: 2px;
  height: 14px;
  background: #ff533c;
  position: absolute;
  left: 0;
  top: 6px;
}

.boxitem {
  background: #f5f7fa;
  border: 1px solid #f5f7fa;
  padding: 0px 20px;
  box-sizing: border-box;
  border-radius: 4px;
  position: relative;
  cursor: pointer;
}

.boxitem.active,
.boxitem:hover {
  background: #f1f7fe;
  border: 1px solid #409eff;
}

.boxitem p:nth-child(1) {
  color: #333;
  font-size: 14px;
  position: relative;
  padding-left: 10px;
}

.boxitem p:nth-child(1) span {
  width: 4px;
  height: 14px;
  position: absolute;
  left: 0;
  top: 4px;
  border-radius: 2px;
}

.boxitem p:nth-child(2) {
  color: #333;
  font-weight: bolder;
  font-size: 24px;
  padding-top: 5px;
}

.color_1 {
  background: #409eff;
}

.color_2 {
  background: #f56c6c;
}

.color_3 {
  background: #387b17;
}

.color_4 {
  background: #e6a23c;
}

.color_5 {
  background: #67c23a;
}

.color_6 {
  background: #be0e0e;
}

.color_7 {
  background: #409eff;
}

.color_8 {
  background: #f56c6c;
}

.color_9 {
  background: #387b17;
}
</style>
<script>
import { gethomedata } from "../../api/order";
import { MrYangUtil } from "../../utils/time.js";
import echarts from "echarts";
import waves from "@/directive/waves"; // waves directive
import Toolbar from "../../components/Toolbar";
export default {
  components: { Toolbar },
  directives: { waves },
  data() {
    return {
      dialogshow: false,
      downloadLoading: false,
      list: [],
      pageIndex: 1,
      total: 0,
      tabPosition: 1,
      orderrecordmain: {},
      servicetime: 0,
      columns: [],
      data: {
        metrics: [
        ],
        columns: [],
        xAxis: [],
        thisdetails: [],
        lastdetails: [],
        paywaylist: [],
        paysourcelist: [],
      },
      salerendname: "营业实收",
      active: "yyss",
      listQuery: {
        pageIndex: 1,
        pageSize: 15,
        orderColumn: "",
        orderbyasc: false,
        querymodel: {
          datetype: 1,
          keyword: "",
          begintime: "",
          endtime: "",
          metricmarkJson: ["yyss", "yfsk", "ccsk", "bjsk", "ykcz", "incount", "outcount", "skipamount"],
        },
      },
    };
  },
  created() {
    var end = new Date();
    end.setHours(23);
    end.setMinutes(59);
    end.setSeconds(59);
    var start = new Date();
    start.setHours(0);
    start.setMinutes(0);
    start.setSeconds(0);
    start.setTime(start.getTime() + this.servicetime);
    end.setTime(end.getTime() + this.servicetime);
    this.listQuery.querymodel.begintime = MrYangUtil.formatdate(start);
    this.listQuery.querymodel.endtime = MrYangUtil.formatdate(end);
    this.getList();
  },
  updated() {
    // this.$nextTick(() => {
    //   this.$refs["orderrecordtable"].doLayout();
    // });
  },
  methods: {
    tableformatter(row, column, cellValue) {
      return Number(cellValue).toFixed(2);
    },
    changedate() {
      this.listQuery.querymodel.datetype = this.tabPosition;
      var end = new Date();
      var start = new Date();
      switch (this.tabPosition.toString()) {
        case "1":
          break;
        case "2":
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
          end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
          break;
        case "3":
          start = MrYangUtil.getCurrentWeek()[0];
          end = MrYangUtil.getCurrentWeek()[1];
          break;
        case "5":
          start = MrYangUtil.getCurrentMonth()[0];
          end = MrYangUtil.getCurrentMonth()[1];
          break;
        case "6":
          start = MrYangUtil.getCurrentYear()[0];
          end = MrYangUtil.getCurrentYear()[1];
          break;
      }
      end.setHours(23);
      end.setMinutes(59);
      end.setSeconds(59);
      start.setHours(0);
      start.setMinutes(0);
      start.setSeconds(0);
      this.listQuery.querymodel.begintime = MrYangUtil.formatdate(start);
      this.listQuery.querymodel.endtime = MrYangUtil.formatdate(end);
      this.getList();
    },
    savecomplete(item) {
      this.dialogshow = false;
      this.getList();
    },
    cancelcomplete() {
      this.dialogshow = false;
    },
    getList(item) {
      if (item != null && item != undefined) {
        this.listQuery.pageIndex = item.page;
        this.listQuery.pageSize = item.limit;
      } else {
        this.listQuery.pageIndex = 1;
      }
      gethomedata(this.listQuery.querymodel).then((res) => {
        this.columns = res.columns;
        this.list = res.thisdetails;
        this.data = res;
        this.initsalestrend();
        this.initpayway();
        this.initpaytype();
      });
    },
    changetype(item) {
      this.active = item.metrimark;
      this.salerendname = item.metriname;
      this.initsalestrend();
    },
    initpayway() {
      let myCharts = echarts.init(document.getElementById("payway"));
      //2.准备数据
      //饼图无需配置 xaxis 和 yaxis  数据是由 value name构成的数组
      let data = this.data.paywaylist;
      //3.配置
      let option = {
        tooltip: {
          trigger: "item",
        },
        color: [
          "#fc8251",
          "#5470c6",
          "#91cd77",
          "#ef6567",
          "#f9c956",
          "#75bedc",
        ],
        series: [
          {
            type: "pie",
            data: data,
            label: {
              //echarts饼图内部显示百分比设置
              show: true,
              position: "outside", //outside 外部显示  inside 内部显示
              formatter: `{b}({d}%)\n金额：{c}`,
              color: "#303133", //颜色
              fontSize: 10, //字体大小
            },
          },
        ],
      };
      //4.渲染图表
      myCharts.setOption(option);
    },
    initpaytype() {
      let myCharts = echarts.init(document.getElementById("paytype"));
      //2.准备数据
      //饼图无需配置 xaxis 和 yaxis  数据是由 value name构成的数组
      let data = this.data.paysourcelist;
      //3.配置
      let option = {
        tooltip: {
          trigger: "item",
        },
        color: [
          "#fc8251",
          "#5470c6",
          "#91cd77",
          "#ef6567",
          "#f9c956",
          "#75bedc",
        ],
        series: [
          {
            type: "pie",
            data: data,
            label: {
              //echarts饼图内部显示百分比设置
              show: true,
              position: "outside", //outside 外部显示  inside 内部显示
              formatter: `{b}({d}%)\n金额：{c}`,
              color: "#303133", //颜色
              fontSize: 10, //字体大小
            },
          },
        ],
      };
      //4.渲染图表
      myCharts.setOption(option);
    },
    initsalestrend() {
      let myChart = echarts.init(document.getElementById("salestrend"));
      let colors = ["#FF884C", "#3F7DF6"];
      let str1 = "上一周期";
      let str2 = "查询周期";
      let td = [];
      let ld = [];
      this.data.thisdetails.forEach((item) => {
        td.push(item[this.active]);
      });
      this.data.lastdetails.forEach((item) => {
        ld.push(item[this.active]);
      });
      td.reverse();
      ld.reverse();
      myChart.setOption({
        color: colors,
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        dataZoom: [
          {
            show: true,
            realtime: true,
            start: 0,
            end: 100,
          },
          {
            type: "inside",
            realtime: true,
            start: 0,
            end: 100,
          },
        ],
        grid: {
          top: 50,
          bottom: 80,
          left: 70,
          right: 50,
        },
        xAxis: [
          {
            type: "category",
            data: this.data.xAxis,
            splitLine: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                color: "#666666",
              },
            },
            axisTick: {
              lineStyle: {
                color: "#666666",
              },
            },
            axisLabel: {
              showMaxLabel: true,
              color: "#666666",
              fontFamily: "PingFangSC",
              fontSize: 14,
              fontWeight: 300,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            show: true,
            splitLine: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                color: "#666666",
              },
            },
            axisTick: {
              lineStyle: {
                color: "#666666",
              },
            },
            axisLabel: {
              showMaxLabel: true,
              color: "#666666",
              fontFamily: "PingFangSC",
              fontSize: 14,
              fontWeight: 300,
              formatter: function (value, index) {
                if (value >= 10000 && value < 10000000) {
                  value = value / 10000 + "万";
                } else if (value >= 10000000 && value < 100000000) {
                  value = value / 10000000 + "千万";
                } else if (value >= 100000000) {
                  value = value / 100000000 + "亿";
                }
                return value;
              },
            },
          },
        ],
        series: [
          {
            name: str1,
            type: "line",
            smooth: 0.4,
            symbol: "circle",
            symbolSize: 5,
            data: ld,
            lineStyle: {
              width: 3,
              shadowColor: "rgba(253, 161, 42, 0.77)",
              shadowBlur: 10,
              shadowOffsetY: 6,
            },
          },
          {
            name: str2,
            type: "line",
            smooth: 0.4,
            symbol: "circle",
            symbolSize: 5,
            data: td,
            lineStyle: {
              width: 3,
              shadowColor: "rgba(41, 123, 239, 0.77)",
              shadowBlur: 10,
              shadowOffsetY: 6,
            },
          },
        ],
      });
    },
  },
  mounted() { },
};
</script>